<template>
  <BContainer
    v-if="user"
  >
    <BRow
      class="pb-5 mx-1"
    >
      <BCol
        cols="12"
        class="px-0"
      >
        <BCard
          class="bg-transparent"
          body-class="p-0 d-flex flex-column flex-md-row min-h-300px rounded shadow-none"
        >
          <div
            class="d-flex flex-column justify-content-between flex-grow-1 px-md-4 px-2 pb-4"
            :style="{
              backgroundImage: `url(${require('@/assets/images/store.png')})`,
              backgroundPosition: 'right bottom',
              backgroundRepeat: 'no-repeat',
              backgroundSize: '200px'
            }"
          >
            <BRow>

              <BCol
                class="p-2"
              >
                <div>
                  <h2 class="text-primary font-weight-bolder">
                    Good {{ greetings }}, {{ user?.name }}!
                  </h2>
                  <h6 class="h6">
                    Here's what's happening in your warehouse ( <b class="text-primary">{{ user?.location_name }}</b> ) today
                  </h6>
                </div>
              </BCol>

              <BCol
                cols="12"
                class="p-2 border-bottom mt-4"
              >
                <h5 class="text-center text-md-left font-weight-bold">
                  Purchase Orders
                </h5>
              </BCol>

              <BCol
                v-if="Number(user.allow_in) === 1"
                cols="12"
                class="px-0"
                style="border-radius: 0; border-bottom: 1px solid #dadada;"
              >
                <BRow
                  class="mx-0"
                >
                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.requests', params: { requester: 'pending' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.pending"
                        title="Pending"
                        sub-title="PO Requests"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.requests', params: { requester: 'pending' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.processing"
                        title="Processing"
                        sub-title="PO Requests"
                        variant="warning"
                        icon="fad fa-file-contract"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.requests', params: { requester: 'histories', status: 'closed' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.closed"
                        title="Closed"
                        sub-title="PO Requests"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.requests', params: { requester: 'histories', status: 'disapproved' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.disapproved"
                        title="Disapproved"
                        sub-title="PO Requests"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

              <BCol
                v-if="Number(user.allow_out) === 1"
                cols="12"
                class="px-0"
              >
                <BRow
                  class="mx-0"
                  style="border-radius: 0; border-bottom: 1px solid #dadada;"
                >
                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.approvals', params: { approver: 'pending' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.approvals.pending"
                        title="Pending"
                        sub-title="PO Approvals"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  />

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.approvals', params: { approver: 'histories', status: 'approved' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.approvals.approved"
                        title="Approved"
                        sub-title="PO Approvals"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.approvals', params: { approver: 'histories', status: 'disapproved' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.approvals.disapproved"
                        title="Disapproved"
                        sub-title="PO Approvals"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>

                </BRow>
              </BCol>

              <BCol
                v-if="Number(user.allow_out) === 1"
                cols="12"
                class="px-0"
              >
                <BRow
                  class="mx-0"
                  style="border-radius: 0; border-bottom: 1px solid #dadada;"
                >
                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.posting', params: { poster: 'pending' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.posting.pending"
                        title="Posting"
                        sub-title="PO Posting"
                        variant="dark"
                        icon="fad fa-file"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.posting', params: { poster: 'unposted' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.posting.unposted"
                        title="Unposted"
                        sub-title="PO Posting"
                        variant="warning"
                        icon="fad fa-file-contract"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.posting', params: { poster: 'histories' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.posting.posted"
                        title="Posted"
                        sub-title="PO Posting"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  />
                  <!-- <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.approvals', params: { approver: 'histories', status: 'canceled' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.approvals.canceled"
                        title="Canceled"
                        sub-title="PO Approvals"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol> -->

                </BRow>
              </BCol>

              <BCol
                v-if="Number(user.allow_in) === 1"
                cols="12"
                class="px-0"
              >
                <BRow
                  class="mx-0"
                >
                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.receiving', params: { receiver: 'pending' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.receiving.pending"
                        title="Receiving"
                        sub-title="PO Receiving"
                        variant="dark"
                        icon="fad fa-file"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  />

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.receiving', params: { receiver: 'histories' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.receiving.received"
                        title="Received"
                        sub-title="PO Receiving"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    class="px-1"
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.purchase-orders.requests', params: { requester: 'histories', status: 'canceled' }}">
                      <SimpleCard
                        :loading="fetching"
                        :count="purchaseOrders.requests.canceled"
                        title="Canceled"
                        sub-title="PO Requests"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

            </BRow>

            <BRow>
              <BCol
                cols="12"
                class="p-2 border-bottom mt-4"
              >
                <h5 class="text-center text-md-left font-weight-bold">
                  Authority to Withdraws
                </h5>
              </BCol>

              <!-- AUTHORITY TO WITHDRAW RECEIVING -->
              <BCol
                cols="12"
                class="px-0"
              >
                <BRow
                  class="py-2 mx-0"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.atws.receiving', params: { receiver: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="atws.receiving.pending"
                        title="Pending"
                        sub-title="ATW Receiving"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  />

                  <BCol
                    cols="12"
                    md="3"
                    class="mb-md-0 mb-5"
                  >
                    <router-link :to="{ name: 'wo.atws.receiving', params: { receiver: 'histories' }}">
                      <Card
                        :loading="fetching"
                        :count="atws.receiving.received"
                        title="Received"
                        sub-title="ATW Receiving"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

            </BRow>

            <BRow>
              <BCol
                cols="12"
                class="p-2 border-bottom mt-4"
              >
                <h5 class="text-center text-md-left font-weight-bold">
                  Inter Warehouse Transfers
                </h5>
              </BCol>

              <!-- INTER WAREHOUSES TRANSFERS -->
              <BCol
                cols="12"
                class="px-0"
              >
                <BRow
                  class="py-2 mx-0"
                  style="border-radius: 0; border-bottom: 1px solid #dadada;"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.inter-warehouses.transfers', params: { transfer: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.pending"
                        title="Pending"
                        sub-title="IW Transfers"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.inter-warehouses.transfers', params: { transfer: 'processing' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.processing"
                        title="Processing"
                        sub-title="IW Transfers"
                        variant="warning"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.inter-warehouses.transfers', params: { transfer: 'histories', status: 'closed' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.closed"
                        title="Closed"
                        sub-title="IW Transfers"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.inter-warehouses.transfers', params: { transfer: 'histories', status: 'disapproved' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.disapproved"
                        title="Disapproved"
                        sub-title="IW Transfers"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>

                </BRow>
              </BCol>

              <!-- INTER WAREHOUSES POSTINGS -->
              <BCol
                cols="12"
                class="px-0"
                style="border-radius: 0; border-bottom: 1px solid #dadada;"
              >
                <BRow
                  class="py-2 mx-0"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.inter-warehouses.posting', params: { poster: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.posting.pending"
                        title="Pending"
                        sub-title="IW Posting"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  />

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.inter-warehouses.posting', params: { poster: 'histories' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.posting.posted"
                        title="Posted"
                        sub-title="IW Posting"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.inter-warehouses.transfers', params: { transfer: 'histories', status: 'canceled' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.transfers.canceled"
                        title="Canceled"
                        sub-title="IW Transfers"
                        variant="danger"
                        icon="fad fa-file-times"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

              <!-- INTER WAREHOUSES RECEIVING -->
              <BCol
                cols="12"
                class="px-0"
              >
                <BRow
                  class="py-2 mx-0"
                >
                  <BCol
                    cols="12"
                    md="3"
                  >
                    <router-link :to="{ name: 'wo.inter-warehouses.receiving', params: { receiver: 'pending' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.receiving.pending"
                        title="Pending"
                        sub-title="IW Receiving"
                        variant="dark"
                        icon="fad fa-file-lines"
                      />
                    </router-link>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                  />

                  <BCol
                    cols="12"
                    md="3"
                    class="mb-md-0 mb-5"
                  >
                    <router-link :to="{ name: 'wo.inter-warehouses.receiving', params: { receiver: 'histories' }}">
                      <Card
                        :loading="fetching"
                        :count="interWarehouses.receiving.received"
                        title="Received"
                        sub-title="IW Receiving"
                        variant="success"
                        icon="fad fa-file-check"
                      />
                    </router-link>
                  </BCol>
                </BRow>
              </BCol>

            </BRow>
          </div>
        </BCard>
      </BCol>
    </BRow>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'
import createDate from 'moment'

import SimpleCard from '@/components/custom/SimpleCard.vue'
import Card from '@/components/custom/Card.vue'

import { SWarehouseDashboard } from '@/services/user/wo'

export default {

  name: 'VWarehouseDashboard',

  middleware: ['auth', 'wo'],

  components: {
    SimpleCard,
    Card
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  metaInfo: () => ({
    title: 'Dashboard'
  }),

  data () {
    return {
      fetching: false,
      borderRight: !this.isMobile(),
      purchaseOrders: {
        requests: {
          pending: 0,
          processing: 0,
          closed: 0,
          disapproved: 0,
          canceled: 0
        },
        approvals: {
          pending: 0,
          processing: 0,
          approved: 0,
          disapproved: 0,
          canceled: 0
        },
        posting: {
          pending: 0,
          unposted: 0,
          posted: 0
        },
        receiving: {
          pending: 0,
          received: 0
        }
      },
      interWarehouses: {
        transfers: {
          pending: 0,
          processing: 0,
          closed: 0,
          disapproved: 0,
          canceled: 0
        },
        posting: {
          pending: 0,
          posted: 0
        },
        receiving: {
          pending: 0,
          received: 0
        }
      },
      atws: {
        receiving: {
          pending: 0,
          received: 0
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),

    greetings () {
      const currentHourOfTheDay = createDate().hour()

      if (currentHourOfTheDay >= 3 && currentHourOfTheDay < 12) {
        return 'Morning'
      } else if (currentHourOfTheDay === 12) {
        return 'Noon'
      } else if (currentHourOfTheDay > 12 && currentHourOfTheDay < 18) {
        return 'Afternoon'
      } else if (currentHourOfTheDay >= 18 && currentHourOfTheDay < 20) {
        return 'Evening'
      } else {
        return 'Night'
      }
    }
  },

  mounted () {
    if (this.user) {
      this.getStatistics()
    }
  },

  methods: {
    async getStatistics () {
      this.fetching = true
      return SWarehouseDashboard.getStatistics().then(
        ({ data }) => {
          this.purchaseOrders.requests = Object.assign(this.purchaseOrders.requests, {
            pending: data?.purchase_order_total_pending || 0,
            processing: data?.purchase_order_total_processing || 0,
            closed: data?.purchase_order_total_closed || 0,
            disapproved: data?.purchase_order_total_disapproved || 0,
            canceled: data?.purchase_order_total_canceled || 0
          })

          this.purchaseOrders.receiving = Object.assign(this.purchaseOrders.receiving, {
            pending: data?.purchase_order_receiving_total_pending || 0,
            received: data?.purchase_order_receiving_total_received || 0
          })

          this.purchaseOrders.approvals = Object.assign(this.purchaseOrders.approvals, {
            pending: data?.purchase_order_approval_total_pending || 0,
            processing: 0,
            approved: data?.purchase_order_approval_total_approved || 0,
            disapproved: data?.purchase_order_approval_total_disapproved || 0,
            canceled: 0
          })

          this.purchaseOrders.posting = Object.assign(this.purchaseOrders.posting, {
            pending: data?.purchase_order_posting_total_pending || 0,
            unposted: data?.purchase_order_posting_total_unposted || 0,
            posted: data?.purchase_order_posting_total_posted || 0
          })

          this.interWarehouses.transfers = Object.assign(this.interWarehouses.transfers, {
            pending: data?.inter_warehouse_total_pending || 0,
            processing: data?.inter_warehouse_total_processing || 0,
            closed: data?.inter_warehouse_total_closed || 0,
            disapproved: data?.inter_warehouse_total_disapproved || 0,
            canceled: data?.inter_warehouse_total_canceled || 0
          })

          this.interWarehouses.posting = Object.assign(this.interWarehouses.posting, {
            pending: data?.inter_warehouse_posting_total_pending || 0,
            posted: data?.inter_warehouse_posting_total_processed || 0
          })

          this.interWarehouses.receiving = Object.assign(this.interWarehouses.receiving, {
            pending: data?.inter_warehouse_receiving_total_pending || 0,
            received: data?.inter_warehouse_receiving_total_processed || 0
          })

          this.atws.receiving = Object.assign(this.atws.receiving, {
            pending: data?.stock_withdrawal_receiving_total_pending || 0,
            received: data?.stock_withdrawal_receiving_total_processed || 0
          })
        }
      ).catch(() => {
        this.purchaseOrders = Object.assign(this.purchaseOrders, {
          requests: {
            pending: 0,
            processing: 0,
            closed: 0,
            disapproved: 0,
            canceled: 0
          },
          approvals: {
            pending: 0,
            processing: 0,
            approved: 0,
            disapproved: 0,
            canceled: 0
          },
          posting: {
            pending: 0,
            unposted: 0,
            posted: 0
          },
          receiving: {
            pending: 0,
            received: 0
          }
        })

        this.interWarehouses = Object.assign(this.interWarehouses, {
          transfers: {
            pending: 0,
            processing: 0,
            closed: 0,
            disapproved: 0,
            canceled: 0
          },
          posting: {
            pending: 0,
            posted: 0
          },
          receiving: {
            pending: 0,
            received: 0
          }
        })

        this.atws = Object.assign(this.atws, {
          receiving: {
            pending: 0,
            received: 0
          }
        })
      }).finally(() => {
        this.fetching = false
      })
    }
  }
}
</script>
<style scoped>

  *.fa-square {
    position: absolute;
    transform: rotate(65deg) !important;
    font-size: 48px;
    left: 10px;
    bottom: 5px;
    color: var(--iq-warning-light);
  }

  *.font-circle {
    position: absolute;
    height: 48px;
    width: 48px;
    border: 2px solid var(--iq-warning-light);
    right: 5px;
    top: 0px;
    border-radius: 50%;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  *.font-inset {
    font-size: 24px;
    color: var(--iq-warning);
  }
</style>
